import {
  handleKeyDown,
  getItem,
  getSinglePurches,
  getFloorAll,
  updateTransaction,
  createStoreTransaction,
  getSingleTransaction,
  createStoreChallan,
  updateChallan,
  getSingleChallan,
  getApproved,
} from "_services";

import {
  CommonDate,
  CommonInput,
  CommonModal,
  CustomSelect,
  Heading,
} from "components";
import { BasicExample } from "components/common/CommonModal/CommonModal";
import { errorSchema, utils } from "helper";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { Images } from "constants";

const AddChallan = () => {
  const initi = {
    challan_number: "",
    date_when_out: "",
    approved_by: "",
    date_when_in: "",
  };

  const itemObj = {
    item: "",
    quantity_out: 0,
    quantity_in: "",
  };

  const navigate = useNavigate();
  const { id, eventView } = useParams();
  const eventRef = useRef(null);
  const mobileRef = useRef(null);
  const nameRef = useRef(null);
  const genderRef = useRef(null);
  const stateRef = useRef(null);
  const [form, setForm] = useState(initi);
  const [initialForm, setInitialForm] = useState(initi);
  const [formError, setFormError] = useState("");
  const [allBuyerList, setAllBuyerList] = useState([]);
  const [allApproveList, setAllApproveList] = useState([]);

  const [allItemList, setAllItemList] = useState([]);
  const [itemList, setItemList] = useState([itemObj]);
  const [initialItemList, setInitialItemList] = useState([itemObj]);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmIsOpen, setConfirmIsOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState({});
  const [initailObject, setInitailObject] = useState([]);
  useEffect(() => {
    if (mobileRef.current) {
      nameRef.current.focus();
    }
  }, []);

  useEffect(() => {
    getBuyerList();
    getItemList();
    getApproveList();
  }, []);

  useEffect(() => {
    if (id) {
      getPurchaseDetails(id);
    }
  }, [id]);

  const getPurchaseDetails = async (id) => {
    try {
      const res = await getSingleChallan(id);
      if (res?.status === 200) {
        const eventData = {
          challan_number: res?.results?.challan_number,
          date_when_out: res?.results?.date_when_out,
          approved_by: res?.results?.approved_by,
        };
        const list = res?.results?.challan_items?.map((i) => {
          return {
            id: i?.id,
            item: i?.item,
            quantity_out: i?.quantity_out,
            quantity_in: i?.quantity_in,
            missing_quantity: i?.missing_quantity,
          };
        });
        const deepCopyList = JSON.parse(JSON.stringify(list));
        //         const deepCopyList = list.map((i) => ({ ...i }));
        // setInitailObject(deepCopyList);
        setInitailObject(deepCopyList);
        setSelectedItems(res?.results?.challan_items?.map((i) => i?.item));
        setItemList(list);
        setForm(eventData);
        setInitialForm(eventData);
      }
    } catch (error) {}
  };

  const getBuyerList = async (url = "") => {
    try {
      const res = await getFloorAll(url);

      if (res?.status === 200) {
        const list = res?.results?.map((i) => {
          return {
            ...i,
            label: i?.name,
            value: i?.id,
          };
        });
        setAllBuyerList(list);
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      toast.error(error);
    } finally {
    }
  };

  const getApproveList = async (url = "") => {
    try {
      const res = await getApproved(url);

      if (res?.status === 200) {
        const list = res?.results?.map((i) => {
          return {
            ...i,
            label: i?.name,
            value: i?.id,
          };
        });
        setAllApproveList(list);
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      toast.error(error);
    } finally {
    }
  };

  const getItemList = async (url = "") => {
    try {
      const buyerFilter = {
        limit:"all"
      }
      const filterParams = new URLSearchParams();
      Object.keys(buyerFilter).forEach((key) => {
        if (buyerFilter[key]) {
          filterParams.append(key, buyerFilter[key]);
        }
      });

      const urlmodify = `${url}?${filterParams.toString()}`;
      const res = await getItem(url,filterParams.toString());

      if (res?.status === 200) {
        const list = res?.results?.map((i) => {
          return {
            ...i,
            label: i?.name,
            value: i?.id,
          };
        });
        setAllItemList(list);
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      toast.error(error);
    } finally {
    }
  };

  const handleOnChange = async (name, value) => {
    setForm((prevForm) => {
      const updatedForm = {
        ...prevForm,
        [name]: value,
      };

      if (formError) {
        utils
          .checkFormError(
            {
              ...updatedForm,
            },
            errorSchema.challanSchema
          )
          .then((validationResult) => {
            if (validationResult === true) {
              setFormError("");
            } else {
              setFormError(validationResult);
            }
          });
      }

      

      return updatedForm;
    });
  };

  const convertToISOFormat = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString();
  };

  const handleSubmit = async () => {
   
    try {
      // Validate form and return if errors are present
      const validationResult = await utils?.checkFormError(
        { ...form, challan_items: itemList },
        id?errorSchema.challanIDSchema:errorSchema.challanSchema
      );
      
     
        if (validationResult !== true) {
          setFormError(validationResult);
          return;
        }
      

      const changedPayload = buildChangedPayload();

      if (Object.keys(changedPayload).length === 0) {
        console.log("No changes detected.");
        return;
      }

      setIsLoading(true);

      const createPayload = {
        challan_number: form?.challan_number,
        approved_by: form?.approved_by,
        date_when_out: new Date(),
        challan_items: itemList?.map((i) => ({ ...i, quantity_in: 0 })),
      };

      const updatePayload = {
        approved_by: form?.approved_by,
        date_when_in: new Date(),
        challan_items: itemList?.map((i) => ({ ...i })),
      };

      // Submit booking update or creation
      if (Object.keys(changedPayload).length !== 0) {
        const bookingResponse = id
          ? await updateChallan({
              payload: updatePayload,
              id,
            })
          : await createStoreChallan(createPayload);

        handleBookingResponse(bookingResponse);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Submission error:", error);
    }
  };

  // Helper function to build changed payload for booking details
  const buildChangedPayload = () => {
    const payload = {};

    const fieldsToCheck = ["buyer", "purchase_date", "purchase_bill_number"];
    fieldsToCheck.forEach((field) => {
      if (form[field] !== initialForm[field]) {
        payload[field] = form[field];
      }
      payload.items = itemList;
      payload.purchase_date = utils.formatDate(form?.purchase_date);
    });

    return payload;
  };

  const handleBookingResponse = (response) => {
    setIsLoading(false);
    if (response?.status === 200 || response?.status === 201) {
      toast.success(response.message);
      navigate("/store/challan");
    } else {
    
    }
  };

  const handleKey = (e, nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextInputRef && nextInputRef.current) {
        nextInputRef.current.focus();
      } else {
        handleSubmit(e);
      }
    } else if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };

  const addItemInput = (e) => {
    e.preventDefault();

    setItemList((preState) => {
      return [...preState, itemObj];
    });
  };

  const removeFromInput = (index) => {
    const newItemIput = [...itemList];
    newItemIput.splice(index, 1);
    setItemList(newItemIput);
  };

  const handleInputChange = async (value, index, name) => {
    const newItem = [...itemList];
    newItem[index][name] = value;
    setItemList(newItem);
    setSelectedItems((prevSelected) => ({
      ...prevSelected,
      [index]: value,
    }));

    if (formError) {
      if (`${formError}${[index]}${[name]}`) {
        const validationResult = await utils.checkFormError(
          { ...form, itemArray: itemList },
          errorSchema.challanSchema
        );

        if (validationResult === true) {
          const newFormError = { ...formError };
          if (newFormError.itemArray && newFormError.itemArray[index]) {
            delete newFormError.itemArray[index][name];
            if (Object.keys(newFormError.itemArray[index]).length === 0) {
              delete newFormError.itemArray[index];
            }
          }
          setFormError(newFormError);
        } else {
          setFormError(validationResult);
        }
      }
    }
  };

  const submitConfirmation = async () => {
    setLoading(false);
    setConfirmIsOpen(false);
  };

  let propsObject = {
    isOpen: confirmIsOpen,
    // closeModal: ()=>setConfirmIsOpen(false),
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitConfirmation,
    isLoadding: loading,
  };

  return (
    <div>
      <Heading title={id ? "Edit Challan" : "Add Challan"} />
      <div className="_addContainer bg-[#FBF9FB]">
        <div className="_midCont_body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 col-lg-12 col-xl-10">
                <div className="_crtDisp_listBx">
                  <div className="">
                    <h4 className="_disPatch_heads">Basic Details</h4>
                    <div className="_fleX_inds">
                      <div className="_divForth">
                        <CommonInput
                          type="text"
                          placeholder="Enter Challan Number "
                          label="Challan Number"
                          name="challan_number"
                          // borderStyle={"borderStyle"}
                          value={form?.challan_number}
                          focus={
                            !!(
                              typeof formError === "object" &&
                              formError?.challan_number
                            )
                          }
                          error={
                            !!(typeof formError === "object")
                              ? formError?.challan_number
                              : ""
                          }
                          onChange={({ target: { name, value } }) => {
                            handleOnChange(name, value);
                          }}
                          ref={nameRef}
                          // onKeyDown={(e) => handleKey(e, mobileRef)}
                          disabled={eventView || id}
                          // onKeyPress={handleKeyDown}
                        />
                      </div>
                      <div className="_divForth">
                        <CustomSelect
                          placeholder="Select Approve By"
                          label="Approve By"
                          options={allApproveList}
                          onSelect={(data) => {
                            handleOnChange("approved_by", data.value);
                          }}
                          focus={
                            !!(
                              typeof formError === "object" &&
                              formError?.approved_by
                            )
                          }
                          error={
                            !!(typeof formError === "object")
                              ? formError?.approved_by
                              : ""
                          }
                          value={form?.approved_by?allApproveList?.find(
                            (i) => i?.id === form?.approved_by
                          ):{label:"",value:""}}
                          ref={mobileRef}
                          enableSearch={true}
                          // isClearOption ={form?.approved_by?true:false}
                          // isClearHandleChange={()=>setForm((pre)=>({...pre,approved_by:""}))}
                          // onEnterSelect={() => eventRef.current.focus()}
                          disabled={eventView}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="">
                    <h4 className="_disPatch_heads">Items Details</h4>
                    <div className="_fleX_inds">
                      {itemList?.map((data, index) => {
                        return (
                          <>
                            <div className="_divForth">
                              <CustomSelect
                                placeholder="Select Item"
                                label="Item"
                                // options={allItemList}
                                options={allItemList.filter(
                                  (item) =>
                                    !Object.values(selectedItems).includes(
                                      item.value
                                    ) // Remove all selected values
                                )}
                                onSelect={(data) => {
                                  handleInputChange(data?.value, index, "item");
                                }}
                                focus={formError[`challan_items[${index}].item`]}
                                error={formError[`challan_items[${index}].item`]}
                                value={
                                  data?.item
                                    ? allItemList?.find(
                                        (i) => i?.value === data?.item
                                      )
                                    : { label: "", value: "" }
                                }
                                ref={eventRef}
                                enableSearch={true}
                                // onEnterSelect={() => stateRef.current.focus()}
                                disabled={eventView}
                              />
                            </div>

                            <div className="_divForth">
                              <CommonInput
                                type="text"
                                placeholder="Enter Quantity Out"
                                label="Quantity Out"
                                name="quantity_out"
                                // borderStyle={"borderStyle"}
                                value={data?.quantity_out}
                                focus={
                                  formError[`challan_items[${index}].quantity_out`]
                                }
                                error={
                                  formError[`challan_items[${index}].quantity_out`]
                                }
                                onChange={({ target: { name, value } }) => {
                                  handleInputChange(value, index, name);
                                }}
                                // ref={mobileRef}
                                // onKeyDown={(e) => handleKey(e, null)}
                                disabled={eventView || id}
                                onKeyPress={handleKeyDown}
                              />
                            </div>

                            {id && (
                              <div className="_divForth">
                                <CommonInput
                                  type="text"
                                  placeholder="Enter Quantity In"
                                  label="Quantity In"
                                  name="quantity_in"
                                  // borderStyle={"borderStyle"}
                                  value={data?.quantity_in}
                                  focus={
                                    formError[`challan_items[${index}].quantity_in`]
                                  }
                                  error={
                                    formError[`challan_items[${index}].quantity_in`]
                                  }
                                  onChange={({ target: { name, value } }) => {
                                    handleInputChange(value, index, name);
                                    // Check if quantity_in is not equal to missing_quantity
                                    //     if (id && !eventView) {
                                    const timeout = setTimeout(() => {
                                      if (
                                        value !== "" &&
                                        value != data.quantity_out
                                      ) {
                                        setConfirmIsOpen(data);
                                      }
                                    }, 300);
                                  }}
                                  ref={mobileRef}
                                  onKeyDown={(e) => handleKey(e, nameRef)}
                                  disabled={eventView}
                                  onKeyPress={handleKeyDown}
                                  whatsAbility={`${
                                    data.quantity_out != data.quantity_in
                                  }`}
                                  borderStyle={`${
                                    data.quantity_out != data.quantity_in
                                      ? "no"
                                      : "yes"
                                  }`}
                                  abilityTitle="Equal"
                                />
                              </div>
                            )}

                            <div className="_divForth">
                              {itemList?.length > 1 && (
                                <div
                                  className="delete_btn"
                                  onClick={() => removeFromInput(index)}
                                >
                                  <div className="_listbtn">
                                    {" "}
                                    <button
                                      className="_del_pl"
                                      onClick={() => removeFromInput(index)}
                                      disabled={eventView}
                                    >
                                      <img
                                        src={Images.DELETEICON.default}
                                        alt=""
                                      />
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                            {!id && <div className="_divForth"></div>}
                          </>
                        );
                      })}

                      <div className="_divForth">
                        <div
                          className="_anvSwitcherNew form-check form-switch"
                          style={{ width: "150px", marginTop: "10px" }}
                        >
                          <div className="_listbtn">
                            <button
                              className="_addComm_btn _builtyPrintBtn"
                              onClick={addItemInput}
                              disabled={eventView}
                            >
                              + Add
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottomFix">
        <button
          className="_addComm_btn"
          type="button"
          onClick={() => handleSubmit()}
          disabled={isLoading||eventView}
        >
          {isLoading ? <BasicExample /> : id ? "Update Challan" : "Add Challan"}
        </button>
      </div>
      {confirmIsOpen && (
        <CommonModal {...propsObject}>
          <p className="p-3">
            {" "}
            Mismatch: Quantity In {confirmIsOpen?.quantity_in} is not equal to
            Missing Quantity {confirmIsOpen.quantity_out}. Do you want to
            proceed?
          </p>
        </CommonModal>
      )}
    </div>
  );
};

export default AddChallan;

export const MessageModal = ({ show, onClose, title, message }) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        {title && <h3>{title}</h3>}
        <p>{message}</p>
        {onClose && <button onClick={onClose}>Close</button>}
      </div>
    </div>
  );
};
